import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function deleteLead(id) {
	var leadFName;
	var leadLName;
	await firebaseRef
		.ref('/kavtek_leads/' + PROJECT_CODE.projectCode + '/' + id)
		.once('value', (snapshot) => {
			leadFName = snapshot.val()?.clientFName;
			leadLName = snapshot.val()?.clientLName;
		});

	await firebaseRef
		.ref('/kavtek_leads/' + PROJECT_CODE.projectCode + '/' + id)
		.remove();

	return `${leadFName} ${leadLName} has been deleted.`;
}
